<div class="storungen">
  <app-bayernwerk-storungen [isIE11]="isIE11" [url]="url" *ngIf="tenant === 'bag'"></app-bayernwerk-storungen>
  <app-avacon-storungen [isIE11]="isIE11" [url]="url" *ngIf="tenant === 'ava'"></app-avacon-storungen>
  <app-hansewerk-storungen [isIE11]="isIE11" [url]="url" *ngIf="tenant === 'shn'"></app-hansewerk-storungen>
  <app-lechwerke-storungen [isIE11]="isIE11" [url]="url" *ngIf="tenant === 'lew'"></app-lechwerke-storungen>
  <app-enviam-storungen [isIE11]="isIE11" [url]="url" *ngIf="tenant === 'envm'"></app-enviam-storungen>
  <app-westenergie-storungen [isIE11]="isIE11" [url]="url" *ngIf="tenant === 'wee'"></app-westenergie-storungen>
  <app-edis-storungen [isIE11]="isIE11" [url]="url" *ngIf="tenant === 'edis'"></app-edis-storungen>
</div>
